'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _translate = require('@esnpm/translate');

var _BaseInput2 = require('./BaseInput');

var _BaseInput3 = _interopRequireDefault(_BaseInput2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _redux = require('redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toggle = (_temp = _class = function (_BaseInput) {
	_inherits(Toggle, _BaseInput);

	function Toggle() {
		_classCallCheck(this, Toggle);

		return _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).apply(this, arguments));
	}

	_createClass(Toggle, [{
		key: 'onToggle',
		value: function onToggle() {
			if (!this.props.disabled) {
				this.setVal(!this.state.val);
				this.props.onFocus();
			}
		}
	}, {
		key: 'render',
		value: function render() {

			var classes = (0, _classnames2.default)({
				'ToggleInput': true,
				'active': this.state.val,
				'disabled': this.props.disabled,
				'input-sm': this.props.bsSize != null && this.props.bsSize == 'sm',
				'input-lg': this.props.bsSize != null && this.props.bsSize == 'lg'
			});

			return _react2.default.createElement(
				_react.Fragment,
				null,
				_react2.default.createElement(
					'div',
					{
						className: classes,
						onClick: this.onToggle.bind(this) },
					_react2.default.createElement(
						'div',
						{ className: 'option option-on btn btn-primary' },
						_react2.default.createElement(
							'span',
							{ className: 'ToggleText' },
							_react2.default.createElement(_translate.Tr, { path: this.props.trOn })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'option option-off btn btn-default' },
						_react2.default.createElement(
							'span',
							{ className: 'ToggleText' },
							_react2.default.createElement(_translate.Tr, { path: this.props.trOff })
						)
					)
				)
			);
		}
	}]);

	return Toggle;
}(_BaseInput3.default), _class.defaultProps = Object.assign({}, _BaseInput3.default.defaultProps, {
	value: false,
	trOn: 'esforms.toggle.on',
	trOff: 'esforms.toggle.off'
}), _class.propTypes = Object.assign({}, _BaseInput3.default.propTypes, {
	value: _propTypes2.default.any,
	trOn: _propTypes2.default.string,
	trOff: _propTypes2.default.string
}), _temp);
exports.default = (0, _redux.compose)()(Toggle);